import type { FanResponseDto } from '@api'

import { apiClientChatting } from '@/utils/axios'

import type { EditBirthdayRequestOptions, PpvStatistics } from '../types'

const editBirthday = ({
  creatorId,
  userId,
  birthday,
}: EditBirthdayRequestOptions) => {
  const birthdayArray = birthday.split('-')
  const year = parseInt(birthdayArray[0])
  const month = parseInt(birthdayArray[1])
  const day = parseInt(birthdayArray[2])

  return apiClientChatting.post(`/of-chat/${creatorId}/user/${userId}/update`, {
    birthday: {
      year: year,
      month: month,
      day: day,
    },
  })
}

const updateNotice = (
  creatorId: number,
  userId: FanResponseDto['id'],
  notice: string,
): Promise<void> => {
  return apiClientChatting.post(`/of-chat/${creatorId}/user/${userId}/update`, {
    notice,
  })
}

const updateLocalTime = (
  creatorId: number,
  userId: FanResponseDto['id'],
  localTime: string,
): Promise<void> => {
  return apiClientChatting.post(`/of-chat/${creatorId}/user/${userId}/update`, {
    localTime,
  })
}
const updateCountry = (
  creatorId: number,
  userId: FanResponseDto['id'],
  country: string | null,
): Promise<void> => {
  return apiClientChatting.post(`/of-chat/${creatorId}/user/${userId}/update`, {
    country,
  })
}

const getPpvStatistics = (
  creatorId: number,
  userId: FanResponseDto['id'],
): Promise<PpvStatistics> => {
  return apiClientChatting
    .get(`/of-chat/${creatorId}/user/${userId}/ppvStatistics`)
    .then((res) => res.data)
}

export const fanInfoService = {
  editBirthday,
  updateNotice,
  updateLocalTime,
  updateCountry,
  getPpvStatistics,
}
